import "./global.css";

import { Toaster } from "@/components/ui/toaster";
import { createRoot } from "react-dom/client";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProviders } from "@/components/providers/AppProviders";
import Index from "./pages/Index";
import Search from "./pages/Search";
import SearchGrid from "./pages/SearchGrid";
import PropertyDetail from "./pages/PropertyDetail";
import NotFound from "./pages/NotFound";
import Anuncie from "./pages/Anuncie";
import Favorites from "./pages/Favorites";

const App = () => (
  <AppProviders>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/search" element={<Search />} />
          <Route path="/search-grid" element={<SearchGrid />} />
          <Route path="/imovel/:codigo" element={<PropertyDetail />} />
          <Route path="/anuncie" element={<Anuncie />} />
          <Route path="/favoritos" element={<Favorites />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </AppProviders>
);

createRoot(document.getElementById("root")!).render(<App />);
